const translations = {
  ENABLE_TWO_FACTOR: '2 要素認証を有効にする',
  ENABLE_TWO_FACTOR_SUBTITLE:
    ' 本人確認のステップが増えるため、IDやパスワードを不正取得した第三者による「なりすまし」を防げます。',
  SET_UP_2FA: '有効にする',
  SETUP_2FA_HEADER: '2 要素認証を設定',
  SETUP_2FA_SUBHEADER:
    '2 要素認証アプリを起動し、下記のQRコードを読み取ってください',
  SETUP_COPY_CODE:
    'QRコードを読み取れない場合、認証コードをコピーして、アプリに入力してください。',
  SETUP_CODE_INPUT_HEADER: 'コードを入力',
  SETUP_CODE_INPUT_SUBHEADER: '2 要素認証コードを確認してください',
  AUTHENTICATE: '認証',
  MFA_INVALID_CODE: 'コードが無効です。正しいコードを入力してください。',
  MFA_ENABLED: '2 要素認証プロセスを有効',
  MFA_ENABLED_SUBHEADER:
    'ログインの際に認証アプリで生成される６桁の認証コードが必要となります。',
  GOT_IT_CTA: 'はい',
  MFA_INPUT_CODE_HEADER: '2 要素認証',
  MFA_INPUT_CODE_SUBHEADER:
    '2 要素認証アプリを起動し、生成された６桁の認証コードを入力してください。',
  ENTER_YOUR_CODE: 'コードを入力',
  MFA_USER_INFO: '表示される理由とは？',
  MFA_NEED_HELP: 'ヘルプ',
  CONTACT_SUPPORT: 'サポートへのお問い合わせ',
  CONTACT_SUPPORT_TOAST: '2 要素認証をリセットするリクエストを承りました',
  MFA_USER_INFO_TOAST: '2 要素認証が有効になりました',

  HRDB_BIOMETRIC_VERIFY_HEADER: 'Intellectアプリで認証',
  HRDB_BIOMETRIC_VERIFY_SUBHEADER:
    'Intellect アプリで生体認証を使用してHRダッシュボードにアクセスする',
  NOTIFICATION_HEADER: 'ログインしようとしていますか？',
  NOTIFICATION_SUBHEADER:
    'Intellectダッシュボードへのログインが本人であることを確認してください',
  VERIFY_STEP1: '通知をタップして、アプリを開いてください。',
  VERIFY_STEP2: '「はい、私です」をクリックし、本人確認を行なってください',
  NO_NOTIFICATION: '通知が届かない場合',
  CLICK_HERE: 'ここをクリック',
  RESEND_NOTIFICATION: '通知を再送信',
  SECONDS_COUNTDOWN: '秒',
  INSTRUCTIONS_HEADER: '何かお困りですか？',
  INSTRUCTIONS_SUBHEADER:
    '以下の項目を確認後、前ページの「再通知を再送信」を選択してください。',
  INSTRUCTIONS_STEP1_HEADER: '最新版にアップデートしてご利用ください',
  INSTRUCTIONS_STEP1_SUBHEADER:
    'Intellectアプリの最新版バージョンをインストールしてください',
  INSTRUCTIONS_STEP2_HEADER: 'Intellectアプリにサインインしたままにする',
  INSTRUCTIONS_STEP2_SUBHEADER:
    'Intellectアプリの最新バージョンにログインしていることを確認してください',
  INSTRUCTIONS_STEP3_HEADER: 'Intellectアプリの通知がオンになっている',
  INSTRUCTIONS_STEP3_SUBHEADER:
    'デバイスの「設定」を開き、Intellectアプリからの通知を許可してください',
  MANY_RETRY: '再試行が多すぎます! しばらくしてからもう一度お試しください。',
  NOTIFICATION_PREVIEW: 'notificationScreenJa',
  NOTIFICATION_PREVIEW_PROD: 'notificationScreenJa-BUWz08AV',
  SESSION_EXPIRED_2FA:
    'セッションの有効期限が切れました。再度、コードをコピーするかスキャンしてください。',
  RESET_2FA_HEADER: '2 要素認証をリセットしますか？',
  RESET_2FA_CTA: '2 要素認証をリセットする',
  RESET_2FA_SUBHEADER: '数時間後に2 要素認証を再び設定できるようになります。',
  REQUEST_RECEIVED_BIOMETRIC:
    'リクエストは送信されました。折り返しご連絡を差し上げますので、今しばらくお待ちください。',
  TRY_AGAIN_LATER: '数分後にもう一度お試しください',

  dashboardViewingUser:
    'リレーションシップマネジャーとしてダッシュボードを表示しています',
  wellbeingAnalytics: 'ウェルビーイング分析',
  adoptionAnalytics: '利用率分析',
  appEngagement: 'エンゲージメント',
  teleHealthUtilization: 'コーチングの利用率',
  adoptionByDept: '部署 / 部門別の利用率',
  adoptionRateOverview: 'Adoption Data',
  totalSignUps:
    'Number of sign-ups to date including the breakdown by department.',
  filterBy: '適用中のフィルター :',
  overallAdoption: '総利用数',
  noOfSignUpsInclBreakdown:
    '国および部署と部門別の内訳を含んだ、これまでの総登録者数',
  breakdownOfSignUpsByCountryOrDept: '国または部署 / 部門別のサインアップ内訳',

  appEngagementDesc:
    'コーチングを除く、Intellectアプリのセルフケアを利用する社員のエンゲージメント状況です。',
  topSessionsToolTipDesc:
    '学習コース、ミニセッション、ガイドジャーナリングの結果を表示しています',
  minutesSpent: '{{ minutes }} 分',
  frequentEmotionsResponses: '{{ count }} 回答',
  noOfResponses: '回答数',
  wellbeingAnalyticsOverview: 'ウェルビーイング分析の概要',
  wellbeingAnalyticsDesc: '従業員ウェルビーイングとストレスレベルの結果',
  insufficientData: '不十分なデータ',
  noData: 'データなし',
  date: '日付',
  bannerMoodName: 'チーム全体の状態',
  bannerMoodTitlePositive: '良い',
  bannerMoodDescriptionPositive: 'チームの全体的な状態は良好です！',
  bannerMoodTitleNeutral: '普通',
  bannerMoodDescriptionNeutral: 'チームの全体的な状態は普通です。',
  bannerMoodTitleNegative: '悪い',
  bannerMoodDescriptionNegative: 'チームの全体的な状態は悪いようです。',
  bannerStressName: '全体のストレスレベル',
  bannerStressTitleVeryHigh: '非常に高い',
  bannerStressDescriptionVeryHigh:
    '長期にわたってストレスレベルが非常に高い状態が続くと、燃え尽き症候群やパフォーマンスの低下につながります。気をつけましょう。',
  bannerStressTitleHigh: '高い',
  bannerStressDescriptionHigh:
    'ストレスレベルが高い状態は、短期間においてはパフォーマンスを向上しますが、長引くと悪影響を及ぼします。',
  bannerStressTitleMed: '普通',
  bannerStressDescriptionMed:
    '適度で健康的なストレスは、エンゲージメント、生産性、そしてパフォーマンスを高めるのに最適です。',
  bannerStressTitleLow: '低い',
  bannerStressDescriptionLow:
    'ストレスレベルが低いのは良いサインかもしれませんが、低すぎても意欲の減退などにつながる可能性があります。',
  chartEmotionFrequencyName: '頻度の高い回答',
  chartEmotionFrequencyDescription:
    '社員が感じている気持ちを、頻度の高い順に示したインサイトです。',
  chartEmployeeWellBeing: '社員のウェルビーイングレベル',
  chartEmployeeStressLevel: '社員のストレスレベル',
  adoptionBarTitle: '総利用数',
  adoptionBarDescription: '総社員数に対する登録の割合',
  adoptionPieTitle: '部署 / 部門別の利用率',
  adoptionPieDescription: '部署 / 部門別の登録内訳',
  totalSessionName: 'セッションの完了',
  totalSessionDescription: '社員が完了したセッションの合計数。',
  activeUsersName: 'セッション / 社員',
  activeUsersDescription: '社員1人あたりが完了したセッション数の平均値。',
  timeSpentTitle: '分の利用',
  timeSpentDescription: 'Intellectアプリを利用した合計時間。',
  topSessionsName: 'Top 5セッション',
  topSessionsDescription:
    '学習コース、ミニセッション、ガイドジャーナリングにおける結果を表示しています',
  creditsUsedName: 'クレジットの利用',
  creditsUsedDescription: '社員が完了したコーチングセッションの合計数。',
  creditsLowName: '人',
  creditsLowDescription: ' クレジット所有数が1以下の社員',
  coachRatingsName: '全体の評価',
  coachRatingDescription: 'コーチングセッションの平均評価。',
  coachTimeSpentName: '分の利用',
  coachTimeSpentDescription: '社員が完了したコーチングセッションの合計時間。',
  coachMatchedName: 'ユーザーが利用',
  coachMatchedDescription: 'コーチと関わったことのある社員数。',
  creditsUsedClinicalDescription: '社員が完了した臨床セッションの合計数。',
  clinicalRatingDescription: '臨床セッションの平均評価。',
  clinicalMatchedDescription: '臨床担当者と関わったことのある社員数。',
  errorNoData: 'データがありません。',
  errorRemoveFilter:
    '社員の匿名性を守るため、データが非表示になっています。フィルターのいずれかを削除してください',
  completedUsersCount: '{{ count }} users',
  signUpCount: 'Signup Count',
  appRetention: 'App Retention',
  newUsers: 'New users',
  repeatUsers: 'Repeat users',
  activeUsers: 'Active users',
  overallInsights: 'Overall Insights',
  otherInsights: 'Other Insights',
  breakdownByDept: 'Breakdown of sign-ups by department',
  sideBarMainAction: ' ',
  sideBarWellBeing: 'ウェルビーイング分析',
  sideBarAdoptionData: 'アプリ利用率分析',
  sideBarAppEngagement: 'アプリエンゲージメント',
  sideBarCoachingUtilisation: 'コーチングの利用率',
  wellBeingTabTitle: 'ウェルビーイング分析',
  wellBeingTabDescription:
    '従業員のウェルビーイングとストレスレベルのデータ集計',
  dateFilterMonthCurrent: '今月',
  dateFilterMonthItem_one: '直近 {{ count }} ヶ月',
  dateFilterMonthItem_other: '直近 {{ count }} ヶ月',
  chartDisplayTitle: 'チャート表示',
  chartDisplayAbsoluteNos: '絶対数',
  chartDisplayPercentage: '比率',
  chartDisplayGrouped: 'グループ',
  filterTitle: 'フィルター',
  filterRegionTitle: '国',
  filterDepartmentTitle: '部署 / 部門',
  filterGenderTitle: '性別',
  filterAgeGroupTitle: '年齢層',
  filterApply: 'フィルターを適用',
  filterCancel: 'キャンセル',
  filterReset: 'リセット',
  filterResetAll: '全てリセット',
  filterSelectAll: '全て選択',
  filterSearch: '検索',
  filterGenderMale: '男性',
  filterGenderFemale: '女性',
  filterGenderNonBinary: 'ノンバイナリー',
  filterGenderUnknown: '無回答',
  NOT_DISCLOSED: '非公開',
  filterAgeValue: '{{- yearValue}} 歳',
  YEARS: '歳',
  filterNoOptionsFound: 'オプションが見つかりません',
  adoptionTabDescription: '現在および過去の従業員を含む、部門別の登録数合計。',
  appEngagementTabDescription: '従業員のセルフケアプログラム利用状況',
  appEngagementLearningPath: '学習コース',
  appEngagementRescue: 'ミニセッション',
  appEngagementJournal: 'ジャーナリング',
  appEngagementCheckIn: 'チェックイン',
  genericTextUsers: '{{ count }} users',
  genericTextResponses: '{{ count }} 回答',
  providerOverallInsights: '利用状況',
  providerOtherInsights: 'その他データ',
  clinicalUtilisation: '臨床セッションの利用状況',
  coachingUtilisation: 'コーチングの利用率',
  logout: 'ログアウト',
  loginIntellect: 'intellect',
  loginLetsSignIn: 'こちらからサインイン',
  loginWelcomeBack: ' 社員の皆さんが、健康でいられますように。',
  loginEmailAddress: 'メールアドレス',
  loginPassword: 'パスワード',
  loginSignIn: 'サインイン',
  loginWhoWeAre:
    'Intellectは、社員のメンタルヘルスケアとウェルビーイングをサポートする、テクノロジー企業です。',
  ssoButtonText: 'SSOでログイン',
  passwordLoginButtonText: 'パスワードでログイン',
  orgNotActivatedSSO: 'このドメインはSSOログインが有効化されていません',
  ssoForEmailIsActive:
    'このメールアドレスはSSOログインが設定されています。SSOでログインしてください。',
  ssoTokenVerifying: '認証しています。しばらくお待ちください。',
  ssoTokenVerifyFailedHeading: '認証に失敗しました。再度お試しください。',
  ssoTokenVerifyFailedText:
    'この画面が自動で閉じない場合は、手動で閉じてください。',
  intellectDimensions: 'ウェルビーイング診断（結果集計)',
  learnMore: 'もっと見る',
  yourScore: 'スコア',
  benchmark: 'ベンチマーク',
  healthyAverageScore: '健康的なベンチマーク水準',
  lastUpdatedOn: '最終更新日：',
  employeeCount: '従業員数：{{ count }} 名',
  low: '低',
  medium: '中',
  high: '高',
  score: 'スコア',
  scoreMeaning: 'スコアが意味すること',
  notEnoughInfo: '情報が不十分です',
  noDataDesc:
    '集計データは、10名以上の社員が診断を実施した場合のみ表示されます。',
  insightsAboveAvg:
    'Intellect 基準の健康的なベンチマーク水準を<br/><span class="text-[#00AA5B] font-bold">{{diff}} ポイント</span>上回っています。',
  insightsBelowAvg:
    'Intellect基準の健康的なベンチマーク水準を<br/><span class="text-[#E8324A] font-bold">{{diff}}ポイント</span>下回っています。',
  insightsAtAvg: 'Intellect 基準の健康的なベンチマークと同じ水準です。',
  generatedReportsNote: '生成されたレポートがここに表示されます。',

  REPORTS: 'レポート',
  REPORT_TYPE: 'レポートの種類を選択',
  INSIGHTS_REPORT: 'インサイト',
  TIMEFRAME: '期間',
  EXPORT_TO: '書き出す',
  GENERATE_REPORT: 'レポートを書き出す',
  PAST_REPORTS: '過去のレポート',
  PAST_REPORTS_SUBHEADER: '過去6ヶ月のレポートをダウンロードする',
  GENERATED_ON: '作成日：',
  REPORT_FOR: '期間：',
  INTERNET_LOST: 'インターネット接続が切断されました',
  MONTH: '月',
  MONTHS: '月',
  OR: 'または',
  DATE: '日付を選択',
  FAILED_TO_GENERATE: '生成に失敗しました',
  DISPLAY_GENERATE_REPORTS: '生成されたレポートがここに表示されます',
  TOAST_REPORT_GENERATED: 'レポートが生成されています',
  TOAST_CONTACT_CS:
    'レポートの生成に失敗しました。CS マネージャーに連絡してください。',
  TOAST_DOWNLOADED: 'ダウンロード成功',
  TOAST_DOWNLOAD_READY: 'レポートをダウンロードする準備ができました',
  LAST: '直近',
  FILTERS_SAMPLE_DATA_NOTE: '',
  organisation: '組織',

  NPS_HEADING: 'こちらのダッシュボードのインサイトの質を評価してください。',
  NPS_RATING_ZERO: 'まったく役に立たない',
  NPS_RATING_TEN: '素晴らしい',
  NPS_THANK_YOU: 'ご意見ありがとうございます。',
};
export default translations;
